<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BarChart from 'shared/components/charts/BarChart.vue';
import { DEFAULT_BAR_CHART, DEFAULT_CHART } from '../constants';

const props = defineProps({
  popularTimes: {
    type: Object,
    default: () => ({}),
  },
});

const DAY_KEYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

const { t } = useI18n();

const dayRows = computed(() =>
  DAY_KEYS.map(key => {
    const hours = props.popularTimes?.[key] || [];
    const peak = hours.reduce(
      (max, hour) => Math.max(max, Number(hour?.busyness) || 0),
      0
    );
    return {
      key,
      label: t(`BUZZ_REPORTS.INSIGHTS.DAYS.${key.toUpperCase()}`),
      peak,
    };
  })
);

const hasData = computed(() => dayRows.value.some(row => row.peak > 0));

const collection = computed(() => ({
  labels: dayRows.value.map(row => row.label),
  datasets: [
    {
      ...DEFAULT_BAR_CHART,
      data: dayRows.value.map(row => row.peak),
      backgroundColor: dayRows.value.map(row =>
        ['saturday', 'sunday'].includes(row.key)
          ? DEFAULT_BAR_CHART.backgroundColor
          : 'rgb(119, 155, 187)'
      ),
      borderRadius: 4,
    },
  ],
}));

const chartOptions = computed(() => ({
  scales: {
    ...DEFAULT_CHART.scales,
    y: {
      ...DEFAULT_CHART.scales.y,
      min: 0,
      max: 100,
      title: {
        display: true,
        text: t('BUZZ_REPORTS.INSIGHTS.BUSYNESS'),
        font: { family: DEFAULT_CHART.scales.y.ticks.fontFamily },
      },
    },
  },
}));
</script>

<template>
  <div v-if="!hasData" class="text-sm text-n-slate-10">
    {{ t('BUZZ_REPORTS.INSIGHTS.NO_FOOTFALL') }}
  </div>
  <div v-else class="h-48">
    <BarChart :collection="collection" :chart-options="chartOptions" />
  </div>
</template>
